import { NgModule } from '@angular/core';
import { ModalsComponent } from './modals.component';
import { ModalsRoutingModule } from './modals-routing.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { BackgroundComponent } from './backround.component';

@NgModule({
  imports: [CommonModule, ModalsRoutingModule, ModalModule.forRoot()],
  declarations: [ModalsComponent, BackgroundComponent],
})
export class ModalsModule {}
